export const LOG_ROCKET_KEY = 'yokxf1/backoffice-f0wqa';
export const MIXPANEL_TOKEN = '36bc8102bd15fc0a7471651e632a1c1d';
